import { useAppConstantsContext } from '@/context/AppConstants';
import { DataCard } from '@/reports/shared/DataCard/DataCard';
import { EmptyVehicleSectionDisclaimer } from '@/reports/shared/ReportSection/EmptyVehicleSectionDisclaimer/EmptyVehicleSectionDisclaimer';
import { HowItWorksCTA } from '@/reports/shared/ReportSection/components';
import {
  AutomobileAuctions,
  AutomobileReportedDamages,
} from '@/reports/types/vehicles';
import { Text } from '@/theme/index';
import { pluralizeString } from '@/utils/pluralizeString';
import { VehicleDamageCard } from './VehicleDamageCard';

interface VehicleDamageProps {
  vehicleAuctionsDamageList: AutomobileAuctions | AutomobileReportedDamages;
}

function HowItWorksCTAContent() {
  const {
    data: { brandName },
  } = useAppConstantsContext();

  return (
    <Text
      variant="body2"
      fontSize="0.9rem"
      color={(theme) => theme.palette.grey[800]}
    >
      {brandName} compiles reports of damages on vehicles sourced from
      nationwide auctions and/or sales listings.
    </Text>
  );
}

export function VehicleDamage({
  vehicleAuctionsDamageList,
}: VehicleDamageProps) {
  const title = `${
    vehicleAuctionsDamageList?.length || 0
  } Damage ${pluralizeString('Report', vehicleAuctionsDamageList?.length)}`;

  return (
    <DataCard testId="vehicle-damage-report-section">
      <Text
        data-cy="report-section-title-text"
        data-testid="report-section-title-text"
        variant="h2"
      >
        {title}
      </Text>
      {vehicleAuctionsDamageList &&
        vehicleAuctionsDamageList.map((damage, index) => (
          <VehicleDamageCard damage={damage} key={index} />
        ))}
      {vehicleAuctionsDamageList?.length === 0 && (
        <>
          <EmptyVehicleSectionDisclaimer title="damage" />
          <HowItWorksCTA content={HowItWorksCTAContent()} />
        </>
      )}
    </DataCard>
  );
}
